import React from "react";

// PMR Travels wide horizontal logo — suitcase + plane + swoosh + PMR + TRAVEL AGENCY
const PMRLogo = ({ height = 44, className = "", primary = "#f59e0b", secondary = "#0f2b5b" }) => (
  <svg
    height={height}
    viewBox="0 0 260 130"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="PMR Travels"
  >
    {/* Airplane (behind, top-right of suitcase) */}
    <g transform="translate(56 6) rotate(28)">
      <path
        d="M 8 20 L 28 22 L 40 8 L 44 10 L 38 26 L 52 30 L 54 34 L 38 34 L 28 46 L 24 44 L 28 32 L 16 30 Z"
        fill={secondary}
      />
    </g>

    {/* Suitcase */}
    <g>
      {/* Handle */}
      <path
        d="M 22 30 Q 22 20 32 20 L 38 20 Q 48 20 48 30 L 48 36 L 44 36 L 44 30 Q 44 24 38 24 L 32 24 Q 26 24 26 30 L 26 36 L 22 36 Z"
        fill={primary}
      />
      {/* Left half (orange) */}
      <path
        d="M 8 38 Q 8 34 12 34 L 33 34 L 33 104 L 12 104 Q 8 104 8 100 Z"
        fill={primary}
      />
      {/* Right half (navy) */}
      <path
        d="M 33 34 L 54 34 Q 58 34 58 38 L 58 100 Q 58 104 54 104 L 33 104 Z"
        fill={secondary}
      />
      {/* White latch/label */}
      <rect x="28" y="62" width="12" height="7" rx="1.5" fill="#fff" opacity="0.95" />
      {/* Wheels */}
      <circle cx="15" cy="108" r="3" fill={secondary} />
      <circle cx="51" cy="108" r="3" fill={primary} />
    </g>

    {/* Orange swoosh arc through the letters */}
    <path
      d="M 0 84 Q 100 118 240 66"
      fill="none"
      stroke={primary}
      strokeWidth="6"
      strokeLinecap="round"
    />

    {/* PMR text — stylised serif */}
    <text
      x="78"
      y="90"
      fontFamily="Georgia, 'Times New Roman', serif"
      fontWeight="700"
      fontSize="78"
      fill={secondary}
      letterSpacing="-2"
    >
      PMR
    </text>

    {/* TRAVEL AGENCY subtitle */}
    <text
      x="80"
      y="116"
      fontFamily="'Poppins', sans-serif"
      fontWeight="600"
      fontSize="14"
      fill={secondary}
      letterSpacing="4"
    >
      TRAVEL AGENCY
    </text>

    {/* Location pin (top-right of R) */}
    <g transform="translate(228 60)">
      <path
        d="M 7 0 C 3.1 0 0 3.1 0 7 C 0 12 7 20 7 20 C 7 20 14 12 14 7 C 14 3.1 10.9 0 7 0 Z"
        fill={primary}
      />
      <circle cx="7" cy="7" r="2.6" fill="#fff" />
    </g>
  </svg>
);

export default PMRLogo;
